import { Text } from '@chakra-ui/react'
import React, { useMemo } from 'react'
import { useAudioSettingsState } from '~/atoms/AudioSettingsState'
import { DropdownSelect } from '~/components/shared/Dropdown/DropdownSelect'

import { usePhoneSettingsStyles } from './componentStyles/PhoneSettings.styles'
import { DefaultSettingsWrapper, SubheadingSection } from './Shared'

export const AudioSettings = () => {
  const styles = usePhoneSettingsStyles()
  const {
    permission: microphonePermission,
    output: {
      devices: outputs,
      preference: [selectedOutputDeviceId, setSelectedOutputDeviceId],
    },
    input: {
      devices: inputs,
      preference: [selectedInputDeviceId, setSelectedInputDeviceId],
    },
  } = useAudioSettingsState()

  const handleSelectAudioOutput = (deviceId: string) => {
    setSelectedOutputDeviceId(deviceId)
  }

  const handleSelectAudioInput = (deviceId: string) => {
    setSelectedInputDeviceId(deviceId)
  }

  const audioSettingsContent = useMemo(() => {
    if (microphonePermission === 'granted') {
      return (
        <>
          <Text sx={styles.text2}>Select sound output source - speakers</Text>
          <DropdownSelect
            items={outputs.map((output) => {
              return { content: output.label, value: output.deviceId }
            })}
            selectedValue={selectedOutputDeviceId}
            onSelect={handleSelectAudioOutput}
          />
          <Text sx={styles.text2}>Select input source - microphone</Text>
          <DropdownSelect
            items={inputs.map((input) => {
              return { content: input.label, value: input.deviceId }
            })}
            selectedValue={selectedInputDeviceId}
            onSelect={handleSelectAudioInput}
          />
        </>
      )
    }

    return (
      <Text sx={styles.text2}>
        To select audio devices, please grant microphone permissions
      </Text>
    )
  }, [
    microphonePermission,
    outputs,
    inputs,
    selectedInputDeviceId,
    selectedOutputDeviceId,
  ])

  return (
    <DefaultSettingsWrapper>
      <SubheadingSection>{audioSettingsContent}</SubheadingSection>
    </DefaultSettingsWrapper>
  )
}
